import { isCanceledAxiosError } from './get-axios-sentry-context';
import { isClientHttpError } from './is-client-http-error';
import { isExceptionLikeObject } from './is-exception-like-object';

export const shouldCaptureException = (error: unknown): boolean => {
  return (
    isExceptionLikeObject(error) &&
    !isCanceledAxiosError(error) &&
    !isClientHttpError(error)
  );
};
